import type { ActivePiece, Board, Rotation } from './types';
import { CW, CCW, kicks } from './pieces';
import { collides } from './board';

/**
 * Reine SRS-Rotation mit Wall-Kicks. Probiert die Kick-Offsets der Reihe nach
 * und gibt den ersten kollisionsfreien Zustand zurück, sonst null.
 */
export function tryRotate(
  board: Board,
  piece: ActivePiece,
  dir: 'cw' | 'ccw',
): ActivePiece | null {
  const from = piece.rotation;
  const to = (dir === 'cw' ? CW[from] : CCW[from]) as Rotation;
  for (const [dx, dy] of kicks(piece.type, from, to)) {
    const cand: ActivePiece = {
      ...piece,
      rotation: to,
      x: piece.x + dx,
      y: piece.y + dy,
    };
    if (!collides(board, cand)) return cand;
  }
  return null;
}
